<template>
    <div class="widget">
        <div class="card" :class="{ 'card--loading': !initialized }">

            <div class="grid-x grid-margin-x">
                <div class="cell small-8 medium-12">
                    <h2 class="card__title">
                        {{ $t('widget.recurringShipments.title') }}
                    </h2>
                </div>
                <div class="cell small-16 medium-12 medium-text-right align-right">
                    <router-link class="card__subtitle" :to="{ name: 'RecurringShipments' }">{{ $t('widget.recurringShipments.export') }}</router-link>
                </div>
            </div>

            <div v-if="initialized && shipments.length > 0">
                <table class="widget-table">
                    <tr>
                        <th class="widget-table__header-cell">{{ $t('widget.recurringShipments.sender') }}</th>
                        <th class="widget-table__header-cell">{{ $t('widget.recurringShipments.receiver') }}</th>
                        <th class="widget-table__header-cell">{{ $t('widget.recurringShipments.days') }}</th>
                    </tr>
                    <tr class="widget-table__row widget-table__grid--2" v-for="(shipment, index) in shipments" :key="index">
                        <td class="widget-table__cell">{{ shipment.from[0].name }}</td>
                        <td class="widget-table__cell">{{ shipment.to[0].name }}</td>
                        <td class="widget-table__cell">
                            <span v-for="(day, index) in shipment.days" :key="index">{{ $t(`global.daysShort.${day}`) }}<template v-if="index !== shipment.days.length - 1">, </template> </span>
                        </td>
                    </tr>
                </table>
            </div>

            <p v-if="initialized && shipments.length <= 0">
                {{ $t('widget.recurringShipments.empty') }}
            </p>

            <router-link :to="{ name: 'RecurringShipments' }" class="card__link">{{ $t('widget.recurringShipments.link') }}</router-link>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from '@/config/axios';
import { transform } from '@/services/recurring-shipment-transformer';
import { longFormat } from '@/services/date-formatter';

export default {
    name: 'RecurringShipmentWidget',

    data: () => ({
        initialized: false,

        shipments: [],
    }),

    mounted() {
        this.initialized = false;

        axios({
            url: '/api/v2/standing-order',
            method: 'GET',
            params: {
                count: 3,
                offset: 0,
                sorting: {
                    field: 'sender',
                    direction: 'asc',
                },
            },
            paramsSerializer: (params) => qs.stringify(params),
        })
            .then((response) => {
                const { data } = response.data;
                const shipments = [];

                data.forEach((dataPoint) => {
                    const shipment = transform(dataPoint);

                    shipments.push(shipment);
                });

                this.shipments = shipments;
                this.initialized = true;
            });
    },

    methods: {
        longFormat,
    },
};
</script>
